module.exports = __webpack_public_path__ + "img/zimbabwe.c5a4202e.svg";